"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const typesafe_actions_1 = require("typesafe-actions");
const immer_1 = __importDefault(require("immer"));
const actionCreators = __importStar(require("./action"));
const initialState = {
    data: { isUserLogged: false },
    mode: 'login',
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.loginSuccess): {
            draft.loginFailed = false;
            draft.data.isUserLogged = true;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.loginFailed): {
            draft.loginFailed = true;
            draft.data.isUserLogged = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setMode): {
            draft.mode = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.signupFailed): {
            draft.signupFailed = true;
            draft.data.isUserLogged = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setActionStatus): {
            draft.action = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setAuthData): {
            draft.data = action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setErrorStatusCode): {
            draft.errorStatusCode = action.payload;
            break;
        }
        default:
            break;
    }
});
exports.default = reducer;
